export default __webpack_public_path__ + "static/media/breast-cancer-venn.3070700f.png";